import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_8: FaireProductEntity = {
  token: "starter_collection_8",
  type: "product",
  name: "Poolside Gossip Puzzle",
  brandName: "Piecework",
  imageUrl: "",
  priceDollars: 38,
  msrpDollars: 76,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
